import { render, staticRenderFns } from "./VouchersReport.vue?vue&type=template&id=467aecfc&scoped=true&"
import script from "./VouchersReport.vue?vue&type=script&lang=js&"
export * from "./VouchersReport.vue?vue&type=script&lang=js&"
import style0 from "./VouchersReport.vue?vue&type=style&index=0&id=467aecfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467aecfc",
  null
  
)

export default component.exports